// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { Card, CardContent } from "@mui/material";
import TrdNav from "./components/trading-nav";
import TrdDocs from "./components/trading-doc";
import "../docs.css";
import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
const tradingVersionRoutes = {
  "v2.5.3": "/products/trading-api-v2.5.3",
  "v2.5.1": "/products/trading-api-v2.5.1",
  "v2.5": "/products/trading-api-v2.5",
  "v2.4": "/products/trading-api-v2.4",
  "v2.3": "/products/trading-api-v2.3",
  "v2.2.4": "/products/trading-api-v2.2.4",
};
function Trading() {
  const [search, setSearch] = useState("");
  const getData = (data) => {
    setSearch(data);
  };
  const scrollRef = useRef(null);
  const navigate = useNavigate();
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={2} px={2} pb={2}>
        <Card
          style={{ maxHeight: 800, overflowY: "auto" }}
          className="onscroll"
          ref={scrollRef}
        >
          <CardContent>
            <Grid container spacing={2} py={2}>
              <Grid item md={2.5} xs={12}>
                <Card className="sticky-nav">
                  <CardContent>
                    <TrdNav
                      searchedData={getData}
                      titleNode={
                        <div className="pdl-nav-title">
                          <span className="pdl-nav-title__name">Trading API</span>
                          <select
                            className="pdl-nav-title__version-select"
                            value="v2.5.3"
                            onChange={(e) => navigate(tradingVersionRoutes[e.target.value])}
                          >
                            {Object.keys(tradingVersionRoutes).map((v) => (
                              <option key={v} value={v}>{v}</option>
                            ))}
                          </select>
                        </div>
                      }
                    />
                  </CardContent>
                </Card>
              </Grid>
              <Grid item md={9.5} xs={12} className="scroll-inside">
                <Grid container spacing={0} py={0}>
                  <TrdDocs scrollRef={scrollRef} search={search} />
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Trading;
